import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const settingsRoute = loggedInNavigator.addRoute(new Route().setPath("/reglages"));
